import { MIN_PASSWORD_LENGTH } from "../../constants";

export type LoginFormFields = "email" | "password";

export interface LoginFormDataType {
  email: string;
  password: string;
}

export interface LoginFields {
  id: string;
  type: string;
  label: string;
  placeholder: string;
  iconName?: string;
  name: LoginFormFields;
  validation: any;
}

export const loginFields: Record<
LoginFormFields,
  LoginFields
> = {
  email:{
    label: "Email",
    id: "email",
    type: "email",
    name: "email",
    placeholder: "Email",
    validation: {
      required: true,
      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    },
  },
  password:{
    label: "Password",
    id: "password",
    type: "password",
    name: "password",
    placeholder: "Password",
    iconName: "eye",
    validation: {
      required: true,
      minLength: MIN_PASSWORD_LENGTH,
    },
  },
};

export const getEmailErrorMessages = ({
  email,
}: any): Record<string, string> => ({
  required: "Email or Password was entered wrong.",
  pattern: "Email or Password was entered wrong.",
  server: email?.message || "Server error",
});

export const getPasswordErrorMessages = ({
  password,
}: any): Record<string, string> => ({
  required: "Email or Password was entered wrong.",
  strength: "Email or Password was entered wrong.",
  minLength: "Email or Password was entered wrong.",
  server: password?.message || "Server error",
});
